import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../../components/Controls/MessageHandler.component';


@Component({
    selector: 'my-maintain-dsd-freeze',
    templateUrl: './MaintainDSDFreeze.component.html'
})
export class MaintainDSDFreezeComponent implements OnInit {

    appSetting: ent.AppSetting;
    userInfo: ent.UserInfo;

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    constructor(private authenticationService: serv.AuthenticationService, private adminService: serv.AdminService, private domainDataService: serv.DomainDataService) {

    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();

    
        this.domainDataService.getAppSettings().subscribe(x => {
            this.appSetting = x.filter(y => y.ID == enums.AppSettingEnum.DSDPlanningFreezeActive)[0];
        });
    }

    isFreezeActive(): boolean {
        return this.appSetting.SettingValue == 'true';
    }

    freezePlanning() {
        this.appSetting.SettingValue = 'true';
        let request: ent.SaveAppSettingRequest = {AppSetting: this.appSetting, SavedByEmployee: this.userInfo.Employee};
        this.adminService.saveAppSettingValue(request).subscribe(x => {
            if (x.Success) {
                x.ValidationMessages[0].MessageText = 'Successfully turned on the DSD Freeze.'
            }
            this.handleResponse(x);
        }, err => {
            var response: ent.Response = { Success: false, ValidationMessages: [{ Category: '', MessageText: 'Error Updating DSD Freeze' }] };
            this.handleResponse(response);
        });
    }

    unfreezePlanning() {
        this.appSetting.SettingValue = 'false';
        let request: ent.SaveAppSettingRequest = {AppSetting: this.appSetting, SavedByEmployee: this.userInfo.Employee};
        this.adminService.saveAppSettingValue(request).subscribe(x => {
            if (x.Success) {
                x.ValidationMessages[0].MessageText = 'Successfully turned off the DSD Freeze.'
            }
            this.handleResponse(x);
        }, err => {
            var response: ent.Response = { Success: false, ValidationMessages: [{ Category: '', MessageText: 'Error Updating DSD Freeze' }] };
            this.handleResponse(response);
        });
    }



    handleResponse(response: ent.Response) {

        this.messageHandlerComponent.handleResponse(response);

    }

}